const I=a=>{const t=window.theme.locale.rootUrl==="/"?"":window.theme.locale.rootUrl;return`${window.location.origin}${t}/products/${a.handle}`},z=a=>a.toString().toLowerCase().replace(/[^a-z0-9]+/g,"-").replace(/-+/g,"-").replace(/^-|-$/g,""),O=(a,t)=>{const l=t.getTemplateOptions("product"),b=l.productPageUrl(a),w=t.getPrice?t.getPrice(a):a.price,q=t.getCompareAtPrice?t.getCompareAtPrice(a):a.compare_at_price,C=t.isProductOnSale(q,w),g=a.images,f=g?g.length:0,M=a.featured_image||(g&&g.length>0?g[0]:null);let h="default";f>1&&(h=l.forceHoverGallery?"hover":"gallery");const x=()=>{var v,d,e;let u="";if(C&&(u+='<div class="product-card__badge badge body-extra-small">Sale<span>%</span></div>'),(e=(d=(v=a.metafields)==null?void 0:v.card)==null?void 0:d.badges)!=null&&e.value)for(const o of a.metafields.card.badges.value)u+=`<div class="product-card__badge badge body-extra-small">${o.name}</div>`;return u?`<div class="product-card__badges">${u}</div>`:""},p=()=>{var v,d,e;let u="";if(a.options_with_values){for(const o of a.options_with_values)if(o.name==="Size"){let _="";for(const i of o.values){const r=a.variants.find(s=>s.option1===i||s.option2===i||s.option3===i),n=r?r.available:!1;_+=`
              <div class="quick-add-form__variant">
                <input
                  type="radio"
                  id="${l.context||"card"}-${a.id}-option-${z(i)}"
                  name="Size"
                  value="${i}"
                  data-variant-id="${(r==null?void 0:r.id)||""}"
                  data-quantity="1"
                  class="quick-add-form__variant-input"
                  ${n?"":"disabled"}
                >
                <label
                  for="${l.context||"card"}-${a.id}-option-${z(i)}"
                  ${n?"":"disabled"}
                  class="quick-add-form__variant-label${n?"":" quick-add-form__variant-label--sold-out"}"
                >
                  <span>${i}</span>
                </label>
              </div>
            `}u+=`
            <div class="quick-add-form__variants-wrapper">
              <div class="quick-add-form__variants">
                ${l.showLabel?'<label for="Size" class="quick-add-form__label">Size</label>':""}
                ${_}
                <div class="quick-add-form__success visually-hidden" data-success>
                  <div class="quick-add-form__success-message" data-success-message>
                    Added to cart
                  </div>
                </div>
              </div>
            </div>
          `}else if(o.name==="Colour"||o.name==="Color"){let _="";for(let i=0;i<Math.min(o.values.length,3);i++){const r=o.values[i],n=a.variants.find(m=>m.option2===r),s=(d=(v=r.swatch)==null?void 0:v.color)==null?void 0:d.rgba,c=(e=r.swatch)==null?void 0:e.image;_+=`
                <input
                  type="radio"
                  id="${l.context||"card"}-${a.id}-color-${z(r)}"
                  name="Color"
                  value="${r}"
                  data-variant-id="${(n==null?void 0:n.id)||""}"
                  class="quick-add-form__variant-input visually-hidden"
                  ${r.selected?"checked":""}
                >
                <label
                  for="${l.context||"card"}-${a.id}-color-${z(r)}"
                  class="quick-add-form__variant-label--swatch${c?" quick-add-form__variant-label--swatch-image":""}"
                  data-product-url="${r.product_url||""}"
                  data-swatch
                  data-color="${z(r)}"
                  ${s||c?`style="${s?`background-color: rgba(${s}); --swatch-color: rgba(${s});`:""}${c?`background-image: url(${c});`:""}"`:`style="--swatch-color: var(--swatch-color-${z(r)});"`}
                >
                  <span class="visually-hidden">${r}</span>
                </label>
              `}o.values.length>3&&(_+=`
                <div class="quick-add-form__color-swatches-more">
                  <span>+${o.values.length-3}</span>
                </div>
              `),u+=`
              <div class="quick-add-form__color-swatches">
                ${l.showLabel?'<label for="Color" class="quick-add-form__label">Color</label>':""}
                ${_}
              </div>
            `}}return u},$=()=>C?`
        <span class="product-card__price--sale">${t.formatCurrency(w)}</span>
        <s class="product-card__price--compare">${t.formatCurrency(q)}</s>
      `:`<span class="product-card__price--regular">${t.formatCurrency(w)}</span>`,k=()=>{if(h==="gallery"&&f>1){let u="";for(let v=0;v<Math.min(f,3);v++){const d=g[v];u+=`
          <a href="${b}" class="product-card__gallery-item" data-slide>
            <img src="${d.src}" alt="${a.title}" loading="lazy">
          </a>
        `}return`
        <div class="product-card__gallery" data-product-card-gallery>
          ${u}
          <div class="product-card__gallery-button product-card__gallery-button--prev" data-prev>
            <svg class="icon icon-chevron-left" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M15 18L9 12L15 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </div>
          <div class="product-card__gallery-button product-card__gallery-button--next" data-next>
            <svg class="icon icon-chevron-right" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M9 6L15 12L9 18" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </div>
          <div class="product-card__gallery-progress-bar" data-gallery-progress-bar>
            <span></span>
          </div>
        </div>
      `}else if(h==="hover"&&f>1){let u="";for(let v=0;v<Math.min(f,2);v++){const d=g[v];u+=`<img src="${d.src}" alt="${a.title}" loading="lazy">`}return`
        <a href="${b}" class="product-card__hover-gallery">
          ${u}
        </a>
      `}else return`
        <a class="product-card__default-image" href="${b}">
          ${M?`<img src="${M.src}" alt="${a.title}" loading="lazy">`:'<div class="placeholder-image"><p class="site-title">CDP</p></div>'}
        </a>
      `};return`
    <product-card
      data-product-card
      class="product-card"
      data-product-handle="${a.handle}"
      data-template-type="${l.forceHoverGallery&&f>1?"card-hover":"card"}"
    >
      <div class="product-card__media">
        ${x()}
        ${k()}
      </div>
      <div class="product-card__meta-wrapper">
        <div class="product-card__meta">
          <p class="product-card__title">${a.title.split(" - ")[0]}</p>
          <div class="product-card__price">
            ${$()}
          </div>
          <div class="product-card__quick-add-form">
            ${p()}
          </div>
          <button
            class="product-card__quick-add-button"
            type="button"
            data-quick-add-modal-toggle
            data-product-url="${a.url||b}"
          >
            <svg class="icon icon-bag" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M8 7.5V5.5C8 3.567 9.567 2 11.5 2C13.433 2 15 3.567 15 5.5V7.5M3 7.5H20V20.5C20 21.328 19.328 22 18.5 22H4.5C3.672 22 3 21.328 3 20.5V7.5Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </button>
        </div>
      </div>
    </product-card>
  `},P=a=>a.toString().toLowerCase().replace(/[^a-z0-9]+/g,"-").replace(/-+/g,"-").replace(/^-|-$/g,""),j=(a,t)=>{const l=t.getTemplateOptions("product"),b=l.productPageUrl(a),w=t.getPrice?t.getPrice(a):a.price,q=t.getCompareAtPrice?t.getCompareAtPrice(a):a.compare_at_price,C=a.images,g=C?C.length:0,f=3,M=g<f?g:f;let h="gallery";g<=1&&(h="default"),g===0&&(h="empty"),l.forceHoverGallery&&(h="hover");let x=0,p=!1;if(a.options_with_values)for(const e of a.options_with_values){const o=e.name.toLowerCase();if(o==="colour"||o==="color"){x=e.values.length,p=x>1;break}}const $=()=>{var o,_,i;let e="";if(a.options_with_values){for(const r of a.options_with_values)if(r.name==="Size"){let n="";for(const s of r.values){const c=a.variants.find(y=>y.option1===s||y.option2===s||y.option3===s),m=c?c.available:!1;n+=`
              <div class="quick-add-form__variant">
                <input
                  type="radio"
                  id="${l.context||"card"}-${a.id}-option-${P(s)}"
                  name="Size"
                  value="${s}"
                  data-variant-id="${(c==null?void 0:c.id)||""}"
                  data-quantity="1"
                  class="quick-add-form__variant-input"
                  ${m?"":"disabled"}
                >
                <label
                  for="${l.context||"card"}-${a.id}-option-${P(s)}"
                  ${m?"":"disabled"}
                  class="quick-add-form__variant-label${m?"":" quick-add-form__variant-label--sold-out"}"
                >
                  <span>${s}</span>
                </label>
              </div>
            `}e+=`
            <div class="quick-add-form__variants-wrapper">
              <div class="quick-add-form__variants">
                ${l.showLabel?'<label for="Size" class="quick-add-form__label">Size</label>':""}
                ${n}
                <div class="quick-add-form__success visually-hidden" data-success>
                  <div class="quick-add-form__success-message" data-success-message>
                    Added to cart
                  </div>
                </div>
              </div>
            </div>
          `}else if(r.name==="Colour"||r.name==="Color"){let n="";for(let s=0;s<Math.min(r.values.length,3);s++){const c=r.values[s],m=a.variants.find(S=>S.option2===c),y=(_=(o=c.swatch)==null?void 0:o.color)==null?void 0:_.rgba,L=(i=c.swatch)==null?void 0:i.image;n+=`
                <input
                  type="radio"
                  id="${l.context||"card"}-${a.id}-color-${P(c)}"
                  name="Color"
                  value="${c}"
                  data-variant-id="${(m==null?void 0:m.id)||""}"
                  class="quick-add-form__variant-input visually-hidden"
                  ${c.selected?"checked":""}
                >
                <label
                  for="${l.context||"card"}-${a.id}-color-${P(c)}"
                  class="quick-add-form__variant-label--swatch${L?" quick-add-form__variant-label--swatch-image":""}"
                  data-product-url="${c.product_url||""}"
                  data-swatch
                  data-color="${P(c)}"
                  ${y||L?`style="${y?`background-color: rgba(${y}); --swatch-color: rgba(${y});`:""}${L?`background-image: url(${L});`:""}"`:`style="--swatch-color: var(--swatch-color-${P(c)});"`}
                >
                  <span class="visually-hidden">${c}</span>
                </label>
              `}r.values.length>3&&(n+=`
                <div class="quick-add-form__color-swatches-more">
                  <span>+${r.values.length-3}</span>
                </div>
              `),e+=`
              <div class="quick-add-form__color-swatches">
                ${l.showLabel?'<label for="Color" class="quick-add-form__label">Color</label>':""}
                ${n}
              </div>
            `}}return e},k=()=>{var o,_,i;let e="";if((i=(_=(o=a.metafields)==null?void 0:o.card)==null?void 0:_.badges)!=null&&i.value)for(const r of a.metafields.card.badges.value)e+=`<div class="product-card__badge badge body-extra-small">${r.name}</div>`;return e?`<div class="product-card__badges">${e}</div>`:""},u=()=>q>w?`
        <span class="product-card__price--sale">${t.formatCurrency(w)}</span>
        <s class="product-card__price--compare">${t.formatCurrency(q)}</s>
      `:`<span class="product-card__price--regular">${t.formatCurrency(w)}</span>`,v=()=>{if(h==="gallery"&&g>1){let e="";for(let o=0;o<Math.min(g,f);o++){const _=C[o];e+=`
          <a href="${b}" class="product-card__gallery-item" data-slide>
            <img src="${_.src}" alt="${a.title}" loading="lazy">
          </a>
        `}return`
        <div class="product-card__gallery" data-product-card-gallery>
          ${e}
          <div class="product-card__gallery-button product-card__gallery-button--prev" data-prev>
            <svg class="icon icon-chevron-left" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M15 18L9 12L15 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </div>
          <div class="product-card__gallery-button product-card__gallery-button--next" data-next>
            <svg class="icon icon-chevron-right" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M9 6L15 12L9 18" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </div>
          <div class="product-card__gallery-pagination body-small" data-pagination>
            <span>1</span><span>/</span><span>${M}</span>
          </div>
        </div>
      `}else if(h==="hover"&&g>1){let e="";for(let o=0;o<Math.min(g,2);o++){const _=C[o];e+=`<img src="${_.src}" alt="${a.title}" loading="lazy">`}return`
        <a href="${b}" class="product-card__hover-gallery">
          ${e}
        </a>
      `}else if(h==="default"){const e=a.featured_image;return`
        <a class="product-card__default-image" href="${b}">
          ${e?`<img src="${e.src}" alt="${a.title}" loading="lazy">`:""}
        </a>
      `}else return'<div class="product-card__gallery-item-image placeholder-svg"></div>'},d=()=>{var _,i,r;const e=(r=(i=(_=a.metafields)==null?void 0:_.card)==null?void 0:i.badges)!=null&&r.value?`
      <div class="product-card__badges--mobile">
        ${k()}
      </div>
    `:"",o=p?`
      <div class="product-card__color-count">
        <span class="body">${x} colours</span>
      </div>
    `:"";return`
      <div class="product-card__meta">
        ${e}
        <p class="product-card__title">${a.title.split(" - ")[0]}</p>
        <div class="product-card__price">
          ${u()}
        </div>
        <div class="product-card__quick-add-form">
          ${$()}
        </div>
        ${o}
      </div>
    `};return`
    <product-card
      data-product-card
      class="product-card"
      data-template-type="card"
      data-product-handle="${a.handle}"
    >
      <div class="product-card__media">
        ${k()}
        ${v()}
        <button
          class="product-card__quick-add-button"
          type="button"
          data-quick-add-modal-toggle
          data-product-url="${a.url||b}"
        >
          <svg class="icon icon-plus" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M12 5V19M5 12H19" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </button>
      </div>
      ${d()}
    </product-card>
  `},H=a=>a.toString().toLowerCase().replace(/[^a-z0-9]+/g,"-").replace(/-+/g,"-").replace(/^-|-$/g,""),U=(a,t)=>{const l=t.getTemplateOptions("product"),b=l.productPageUrl(a),w=t.getPrice?t.getPrice(a):a.price,q=t.getCompareAtPrice?t.getCompareAtPrice(a):a.compare_at_price,C=q>w,g=a.images,f=g?g.length:0,M=3;let h="hover";f<=1&&(h="default"),l.forceGallery&&(h="gallery");const x=()=>{var e,o,_;let d="";if(a.options_with_values){for(const i of a.options_with_values)if(i.name==="Size"){let r="";for(const n of i.values){const s=a.variants.find(m=>m.option1===n||m.option2===n||m.option3===n),c=s?s.available:!1;r+=`
              <div class="quick-add-form__variant">
                <input
                  type="radio"
                  id="${l.context||"card"}-${a.id}-option-${H(n)}"
                  name="Size"
                  value="${n}"
                  data-variant-id="${(s==null?void 0:s.id)||""}"
                  data-quantity="1"
                  class="quick-add-form__variant-input"
                  ${c?"":"disabled"}
                >
                <label
                  for="${l.context||"card"}-${a.id}-option-${H(n)}"
                  ${c?"":"disabled"}
                  class="quick-add-form__variant-label${c?"":" quick-add-form__variant-label--sold-out"}"
                >
                  <span>${n}</span>
                </label>
              </div>
            `}d+=`
            <div class="quick-add-form__variants-wrapper">
              <div class="quick-add-form__variants">
                ${l.showLabel?'<label for="Size" class="quick-add-form__label">Size</label>':""}
                ${r}
                <div class="quick-add-form__success visually-hidden" data-success>
                  <div class="quick-add-form__success-message" data-success-message>
                    Added to cart
                  </div>
                </div>
              </div>
            </div>
          `}else if(i.name==="Colour"||i.name==="Color"){let r="";for(let n=0;n<Math.min(i.values.length,3);n++){const s=i.values[n],c=a.variants.find(L=>L.option2===s),m=(o=(e=s.swatch)==null?void 0:e.color)==null?void 0:o.rgba,y=(_=s.swatch)==null?void 0:_.image;r+=`
                <input
                  type="radio"
                  id="${l.context||"card"}-${a.id}-color-${H(s)}"
                  name="Color"
                  value="${s}"
                  data-variant-id="${(c==null?void 0:c.id)||""}"
                  class="quick-add-form__variant-input visually-hidden"
                  ${s.selected?"checked":""}
                >
                <label
                  for="${l.context||"card"}-${a.id}-color-${H(s)}"
                  class="quick-add-form__variant-label--swatch${y?" quick-add-form__variant-label--swatch-image":""}"
                  data-product-url="${s.product_url||""}"
                  data-swatch
                  data-color="${H(s)}"
                  ${m||y?`style="${m?`background-color: rgba(${m}); --swatch-color: rgba(${m});`:""}${y?`background-image: url(${y});`:""}"`:`style="--swatch-color: var(--swatch-color-${H(s)});"`}
                >
                  <span class="visually-hidden">${s}</span>
                </label>
              `}i.values.length>3&&(r+=`
                <div class="quick-add-form__color-swatches-more">
                  <span>+${i.values.length-3}</span>
                </div>
              `),d+=`
              <div class="quick-add-form__color-swatches">
                ${l.showLabel?'<label for="Color" class="quick-add-form__label">Color</label>':""}
                ${r}
              </div>
            `}}return d},p=()=>{var o,_,i,r,n,s,c,m,y,L;let d="";if(C||((i=(_=(o=a.metafields)==null?void 0:o.card)==null?void 0:_.badges)==null?void 0:i.value)){if(C){const S=Math.round((q-w)*100/q);d+=`
          <div class="product-card__badge badge product-card__badge--sale">
            Save <span>${S}%</span>
          </div>
        `}if((s=(n=(r=a.metafields)==null?void 0:r.card)==null?void 0:n.badges)!=null&&s.value)for(const S of a.metafields.card.badges.value){const B=[];(m=(c=S.metafields)==null?void 0:c.card)!=null&&m.background&&B.push(`--badge-background: ${S.metafields.card.background}`),(L=(y=S.metafields)==null?void 0:y.card)!=null&&L.text_color&&B.push(`--badge-color: ${S.metafields.card.text_color}`);const A=B.length>0?` style="${B.join("; ")}"`:"";d+=`<div class="product-card__badge badge"${A}>${S.name}</div>`}}return d?`<div class="product-card__badges">${d}</div>`:""},$=()=>`
      <div class="product-card__price-wrapper">
        ${C?`<s class="product-card__price--compare">${t.formatCurrency(q)}</s>`:""}
        <span class="product-card__price--${C?"sale":"regular"}">${t.formatCurrency(w)}</span>
      </div>
    `,k=()=>{if(h==="gallery"&&f>1){let d="";for(let e=0;e<Math.min(f,M);e++){const o=g[e];d+=`
          <a href="${b}" class="product-card__gallery-item" data-slide>
            <img src="${o.src}" alt="${a.title}" loading="lazy">
          </a>
        `}return`
        <div class="product-card__gallery" data-product-card-gallery>
          ${d}
          <div class="product-card__gallery-button product-card__gallery-button--prev" data-prev>
            <svg class="icon icon-chevron-left" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M15 18L9 12L15 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </div>
          <div class="product-card__gallery-button product-card__gallery-button--next" data-next>
            <svg class="icon icon-chevron-right" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M9 6L15 12L9 18" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </div>
          <div class="product-card__gallery-progress-bar" data-gallery-progress-bar>
            <span></span>
          </div>
        </div>
      `}else if(h==="hover"&&f>1){let d="";for(let e=0;e<Math.min(f,2);e++){const o=g[e];d+=`<img src="${o.src}" alt="${a.title}" loading="lazy">`}return`
        <a href="${b}" class="product-card__hover-gallery">
          ${d}
        </a>
      `}else{const d=a.featured_image;return`
        <a class="product-card__default-image" href="${b}">
          ${d?`<img src="${d.src}" alt="${a.title}" loading="lazy" placeholder="product">`:'<div class="product-card__placeholder placeholder-svg"></div>'}
        </a>
      `}},u=()=>`
      <button class="product-card__wishlist-button product-card__cta" type="button">
        <svg class="icon icon-heart" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M20.84 4.61C20.3292 4.099 19.7228 3.69364 19.0554 3.41708C18.3879 3.14052 17.6725 2.99817 16.95 2.99817C16.2275 2.99817 15.5121 3.14052 14.8446 3.41708C14.1772 3.69364 13.5708 4.099 13.06 4.61L12 5.67L10.94 4.61C9.9083 3.5783 8.50903 2.9987 7.05 2.9987C5.59096 2.9987 4.19169 3.5783 3.16 4.61C2.1283 5.6417 1.5487 7.04097 1.5487 8.5C1.5487 9.95903 2.1283 11.3583 3.16 12.39L4.22 13.45L12 21.23L19.78 13.45L20.84 12.39C21.351 11.8792 21.7563 11.2728 22.0329 10.6053C22.3095 9.93789 22.4518 9.22248 22.4518 8.5C22.4518 7.77752 22.3095 7.06211 22.0329 6.39467C21.7563 5.72723 21.351 5.1208 20.84 4.61V4.61Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </button>
    `,v=()=>{const d=`
      <div class="product-card__badges-mobile">
        ${p()}
      </div>
    `;return`
      <div class="product-card__meta">
        <p class="product-card__title">${a.title.charAt(0).toUpperCase()+a.title.slice(1).toLowerCase().split(" - ")[0]}</p>
        <div class="product-card__price">
          ${$()}
        </div>
        ${d}
      </div>
    `};return`
    <product-card
      data-product-card
      class="product-card"
      data-template-type="card"
      data-product-handle="${a.handle}"
    >
      <div class="product-card__media">
        ${p()}
        ${u()}
        ${k()}
        <div class="product-card__ctas">
          <button
            class="product-card__quick-add-button product-card__cta"
            type="button"
            data-quick-add-modal-toggle
            data-product-url="${a.url||b}"
          >
            <svg class="icon icon-plus" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M12 5V19M5 12H19" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </button>
          ${u()}
        </div>
        <div class="product-card__quick-add-form">
          ${x()}
        </div>
      </div>
      ${v()}
    </product-card>
  `},T=(a,t)=>{var w;const l=((w=window.theme)==null?void 0:w.brandEnvironment)||"cdp";switch(l==="gia"?"iamgia":l){case"iamgia":return j(a,t);case"tigermist":return U(a,t);case"cdp":default:return O(a,t)}},D=(a,t)=>{var g,f,M,h,x;const l=((g=t==null?void 0:t.dataset)==null?void 0:g.sectionId)||"no-results",b=(f=t==null?void 0:t.dataset)==null?void 0:f.title,w=(M=t==null?void 0:t.dataset)==null?void 0:M.headingSize,q=(h=t==null?void 0:t.dataset)==null?void 0:h.buttonLabel,C=(x=t==null?void 0:t.dataset)==null?void 0:x.buttonUrl;return{widget:{options:{limit:a,displayFormat:"grid",includeTagalysCSS:!1},render:(p,$)=>{const k=$.props,v=k.helpers.getProducts();if(k.loading===!1)return v.length===0?null:p`
            <${$.templates.title} />
            <${$.templates.productList} />
            <${$.templates.button} />
          `}},title:{render:p=>b?p`
            <div class="product-recommendations__title">
              <h2 class="title inline-richtext ${w}">${b}</h2>
            </div>
          `:p``},productList:{render:(p,$)=>p`
        <slider-component class="slider-component-full-width">
          <${$.templates.products} />
        </slider-component>
      `},products:{render:(p,$)=>{const u=$.props.helpers.getProducts();return p`<ul
          id="Slider-${l}"
          class="results-grid results-grid--default list-inline m-results-grid--2"
        >
          ${u.map((v,d)=>p`<li class="results-grid__tile">
                <${$.templates.product} key=${d} product=${v} />
              </li>`)}
        </ul> `}},product:{options:{productPageUrl(p){return I(p)}},render:(p,$)=>{const k=$.props,u=k.product,v=k.helpers;return p`<div
          class="tagalys-section__slide"
          id="Slide-${u.id}"
          dangerouslySetInnerHTML=${{__html:T(u,v)}}
        />`}},carouselActions:{render:p=>{var $,k,u,v,d,e;return p`
        <div class="slider-buttons">
          <button
            type="button"
            class="slider-button slider-button--prev"
            name="previous"
            aria-label="${(u=(k=($=window.theme)==null?void 0:$.strings)==null?void 0:k.accessibility)==null?void 0:u.previousSlide}"
            aria-controls="Slider-${l}"
          >
            <span class="svg-wrapper">
              <svg
                class="icon icon--arrow-right"
                aria-label="Icon arrow right"
                width="8"
                height="9"
                viewBox="0 0 8 9"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path d="M0 4.43945H7" stroke="currentColor"></path>
                <path d="M3.28711 0.787109L7.00015 4.50015L3.28711 8.2132" stroke="currentColor"></path>
              </svg>
            </span>
          </button>
          <button
            type="button"
            class="slider-button slider-button--next"
            name="next"
            aria-label="${(e=(d=(v=window.theme)==null?void 0:v.strings)==null?void 0:d.accessibility)==null?void 0:e.nextSlide}"
            aria-controls="Slider-${l}"
          >
            <span class="svg-wrapper">
              <svg
                class="icon icon--arrow-right"
                aria-label="Icon arrow right"
                width="8"
                height="9"
                viewBox="0 0 8 9"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path d="M0 4.43945H7" stroke="currentColor"></path>
                <path d="M3.28711 0.787109L7.00015 4.50015L3.28711 8.2132" stroke="currentColor"></path>
              </svg>
            </span>
          </button>
        </div>
      `}},button:{render:p=>q&&C?p`
            <div class="product-recommendations__button">
              <a href="${C}" class="button button--secondary">${q}</a>
            </div>
          `:p``}}};export{I as c,T as r,D as t};
